<div class="sso">
  <div class="sso__icon">
    <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-vertical"></app-icon>
  </div>

  <div class="sso__form">
    <h2 class="redirect-text">Select a User</h2>

    <div class="card-list">

      <div *ngIf="isLoading" class="card-list__empty">
        Loading...
      </div>

      <ng-container *ngIf="!isLoading">
        <div
          *ngFor="let persona of personas; trackBy: trackByIndex"
          class="card"
          [class.card--hovered]="hoveredId === persona.userId"
          [class.card--selected]="selectedId === persona.userId"
          (mouseenter)="onMouseEnter(persona.userId)"
          (mouseleave)="onMouseLeave()"
          (click)="selectPersona(persona)"
        >
          <div class="card__avatar" [style.background]="getColor(persona.organizationId)">
            {{ getInitials(persona) }}
          </div>
          <div class="card__info">
            <div class="card__name">{{ persona.firstName }} {{ persona.lastName }}</div>
            <div class="card__sub">@{{ persona.username }}</div>
            <div class="card__sub">{{ persona.email }}</div>
            <div class="card__badges">
              <span class="badge badge--org">{{ persona.organizationName }}</span>
              <span class="badge badge--id">ID: {{ persona.userId }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="isEmpty" class="card-list__empty">
          No users found.
        </div>

      </ng-container>

    </div>
  </div>
</div>